export enum SubjectProductSlug {
  ela = "ela",
  science = "science",
  social_studies = "social_studies",
  stem = "stem",
}

export enum SubjectProductLabel {
  ela = "ELA",
  science = "Science",
  social_studies = "Social Studies",
  stem = "STEM",
}

export enum SubjectProductAbbreviation {
  ela = "ELA",
  science = "Science",
  social_studies = "SS",
  stem = "STEM",
}
